import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import './PolicyPages.css';

const RefundPolicy = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="policy-page">
      {/* Header */}
      <div className="policy-header">
        <div className="policy-header-content">
          <button className="back-button" onClick={handleGoBack}>
            <ArrowLeft size={20} />
            <span>Back</span>
          </button>
          <div className="policy-title-section">
            <div className="policy-icon">
              <Shield size={32} />
            </div>
            <h1>Refund & Returns Policy</h1>
            <p>IPH Pharmaceuticals – Authorised Distributor of Chalmers Dale in South East Asia</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="policy-content">
        <div className="policy-container">

          {/* Main Content */}
          <div className="policy-main-content">

            <section className="policy-section">
              <div className="policy-text">
                <p>
                  At IPH Pharmaceuticals, we are committed to delivering authentic Chalmers Dale skincare and personal care products with the highest standards of quality, safety, and hygiene. Due to the nature of cosmetic and personal care products, our return policy is designed to protect product integrity while ensuring customer confidence.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>7-Day Return Window</h2>
              <div className="policy-text">
                <p>
                  Customers may request a return within 7 calendar days from the date of delivery. Requests submitted after this period may not be accepted.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Eligibility for Returns</h2>
              <div className="policy-text">
                <p>Returns will only be accepted under the following circumstances:</p>
                <ul>
                  <li>The product received is damaged, defective, expired, or incorrect</li>
                  <li>The request is made within the 7-day return period</li>
                  <li>The product is unused, unopened, and in original condition</li>
                  <li>All seals, packaging, and safety labels remain intact</li>
                  <li>Proof of purchase and supporting photos are provided</li>
                </ul>
                <p>
                  For hygiene and safety reasons, opened or used skincare and personal care products cannot be returned unless a verified manufacturing defect is confirmed.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Non-Eligible Returns</h2>
              <div className="policy-text">
                <p>The following situations are not eligible for return, refund, or exchange:</p>
                <ul>
                  <li>Change of mind or personal preference</li>
                  <li>Incorrect product selection by the customer</li>
                  <li>Duplicate or accidental purchases</li>
                  <li>Skin sensitivity, intolerance, or allergic reactions</li>
                  <li>Opened, used, or tampered products</li>
                  <li>Missing original packaging or broken seals</li>
                  <li>Products exposed to improper storage conditions such as heat, humidity, or contamination</li>
                  <li>Claims related to individual results, as outcomes may vary</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>Return Authorisation</h2>
              <div className="policy-text">
                <p>
                  All returns must be approved in advance. Customers must contact <a href="mailto:shern@iphrx.com.my">shern@iphrx.com.my</a> and <a href="mailto:iphrx7@gmail.com">iphrx7@gmail.com</a> with their order details, reason for return, and supporting evidence.
                </p>
                <p>
                  If approved, return instructions will be provided. Products returned without prior authorisation may not be accepted.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Return Shipping</h2>
              <div className="policy-text">
                <p>
                  Customers are responsible for return shipping unless the product is confirmed defective or incorrect. We recommend using a trackable courier. IPH Pharmaceuticals is not responsible for items lost or damaged during return transit.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Inspection & Resolution</h2>
              <div className="policy-text">
                <p>
                  All returned products will be inspected upon receipt. Where a claim is verified, IPH Pharmaceuticals may, at its discretion:
                </p>
                <ul>
                  <li>Replace the product with the same item (subject to availability), or</li>
                  <li>Issue a refund or store credit.</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>Refund Processing</h2>
              <div className="policy-text">
                <p>
                  Approved refunds will be processed within 10–14 business days after inspection. Processing timelines may vary depending on the payment provider.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Skin Sensitivity & Patch Test</h2>
              <div className="policy-text">
                <p>
                  As individual skin types and sensitivities vary, we strongly recommend performing a patch test before using any new skincare or personal care product.
                </p>
                <p><strong>Patch Test Guidance:</strong></p>
                <ul>
                  <li>Apply a small amount of the product to a discreet area and observe for 24 hours before full application.</li>
                </ul>
                <p><strong>If irritation or discomfort occurs:</strong></p>
                <ul>
                  <li>Discontinue use immediately</li>
                  <li>Contact our customer care team within 48 hours</li>
                  <li>Provide photos and a brief description of the symptoms</li>
                </ul>
                <p>
                  Skin sensitivity or allergic reactions do not automatically qualify for a refund. However, each case will be reviewed individually, and we may offer consultation, replacement, or store credit at our discretion.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Product & Medical Disclaimer</h2>
              <div className="policy-text">
                <p>
                  Chalmers Dale’s cosmetic and personal care products are not intended to diagnose, treat, cure, or prevent any medical condition. Customers with known allergies, sensitive skin, or dermatological concerns should consult a healthcare professional before use.
                </p>
                <p>IPH Pharmaceuticals is not responsible for adverse reactions arising from:</p>
                <ul>
                  <li>Known or undisclosed allergies</li>
                  <li>Failure to perform a patch test</li>
                  <li>Combination with other skincare, cosmetic, or aesthetic treatments</li>
                  <li>Improper storage or usage</li>
                </ul>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
